import React, { useLayoutEffect } from 'react';

import Overview from './Overview';
import CreditReports from './CreditReports';

import { useNavigate, useParams, useLocation } from 'react-router-dom';

export default function Credit({ borrowers, refetchBorrowers }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  // Redirect to the first credit sublink if no subpath is provided
  useLayoutEffect(() => {
    if (location.pathname === `/loan-files/${id}/credit`) {
      navigate(`/loan-files/${id}/credit/overview`, { replace: true });
    }
  }, [location.pathname, id, navigate]);

  return (
    <div className="h-full bg-white">
      {location.pathname === `/loan-files/${id}/credit/overview` && (
        <Overview />
      )}
      {location.pathname === `/loan-files/${id}/credit/reports` && (
        <CreditReports
          borrowers={borrowers}
          refetchBorrowers={refetchBorrowers}
        />
      )}
    </div>
  );
}
